import { render } from "./CultureBanner.vue?vue&type=template&id=1c78597f&scoped=true"
import script from "./CultureBanner.vue?vue&type=script&lang=js"
export * from "./CultureBanner.vue?vue&type=script&lang=js"

import "./CultureBanner.vue?vue&type=style&index=0&id=1c78597f&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c78597f"]])

export default __exports__